import * as moment from 'moment'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)

const translateError = 'returned an object instead of string'

const validDate = new RegExp(
  '^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]+)?([zZ]|([+-])([01]d|2[0-3]):?([0-5]d)?)?$'
)

const underscoreToString = (text) => {
  const tempText = text
    .replace(/_/g, (_) => {
      return ' '
    })
    .toLowerCase()
  return tempText.charAt(0).toUpperCase() + tempText.slice(1)
}

const toStringToUnderscore = (text) => {
  return text.replace(/ /g, () => {
    return '_'
  })
}

const standardDate = (date) => {
  if (date && typeof date === 'object') {
    return date.toDate()
  }
  return date
}

const formatDates = (date, format) => {
  switch (format) {
    case 'shortTime':
      return moment(date).format('M/D/YY - h:mm A')
    case 'withoutYear':
      return moment(date).format('D MMM, h:mm A')
    case 'hour':
      return moment(date).format('h:mm A')
    case 'shortHour':
      return moment(date).format('h:mm')
    case 'deliveryTime':
      return `${moment(date).format('D MMM, h:mm')} -
        ${moment(date).add(1, 'h').format('h:mm A')}`
    default:
      return moment(date).format('MMM D YYYY, h:mm A')
  }
}

const getFormatText = (text, LIMIT_WORDS) => {
  const splitText = text.split(' ')
  const numOfWords = splitText.length
  let formattedText = '"'
  if (numOfWords >= LIMIT_WORDS) {
    for (let idx = 0; idx < LIMIT_WORDS; idx += 1) {
      if (idx === LIMIT_WORDS - 1) {
        formattedText += `${splitText[idx]}${splitText[numOfWords - 1] === splitText[idx] ? '"' : '..."'}`
      } else {
        formattedText += `${splitText[idx]} `
      }
    }
    return formattedText
  }
  return `"${text}"`
}

const getOperationalModel = (t) => ({
  PICK_AND_DELIVERY: t('jobs.job.info.homeDelivery'),
  PICK_AND_DELIVERY_WITH_STORAGE: t('jobs.job.info.homeDelivery'),
  PICK_AND_COLLECT: t('jobs.job.info.storeDelivery'),
  FULL_SERVICE: t('jobs.job.info.homeDelivery'),
  PICK_AND_COLLECT_NO_TRANSFER: t('jobs.job.info.storeDelivery'),
  PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER: t('jobs.job.info.homeDelivery')
})

const getCheckoutInfo = (tasks) => {
  const CHECKING_OUT = 'CHECKING_OUT'
  const checkoutTask = tasks.find((task) => task.steps.find((step) => step.type.name === CHECKING_OUT))
  if (checkoutTask) {
    const checkStep = checkoutTask.steps.find((step) => step.type.name === CHECKING_OUT)
    return {
      resource: checkoutTask && checkoutTask.resources,
      actualEnd: checkStep && checkStep.actualEnd
    }
  }
  return null
}

const translateJsonKeysByCategory = (t, category, json, tz) => {
  if (!t) throw new Error('Translate function t is needed')
  let translatedObject = {}
  if (json && Object.keys(json).length > 0) {
    Object.keys(json).forEach((key) => {
      let objectCategory, translatedKey
      if (Array.isArray(json)) {
        objectCategory = category
        const route = category.split('.')
        const arrayCategory = t(`${category}.${route[route.length - 1]}`)
        translatedKey = `${t(arrayCategory)} ${key}`
      } else {
        objectCategory = `${category}.${key}`
        translatedKey = t(objectCategory) ? t(objectCategory) : t(`${objectCategory}-base`)
        if (translatedKey?.includes(translateError)) {
          translatedKey = t(`${objectCategory}.${key}`)
        }
      }
      if (typeof json[key] === 'object' && Object.keys(json).length > 0) {
        if (!Array.isArray(json)) {
          translatedKey = t(`${objectCategory}.${key}`)
        }
        translatedObject[translatedKey] = translateJsonKeysByCategory(t, objectCategory, json[key], tz)
      } else {
        translatedObject[translatedKey] = validDate.test(json[key])
          ? moment(json[key]).tz(tz).format('DD/MM/YYYY - HH:mm')
          : t(json[key])
      }
    })
  }
  return translatedObject
}

const isPickingInProgress = (tasks) => {
  const PICKING = 'PICKING'
  const pickingTasks = tasks.filter(({ steps }) =>
    steps.find(({ type: { name }, status }) => name === PICKING && status === 'DONE')
  )

  return pickingTasks.length === 0
}

export {
  underscoreToString,
  toStringToUnderscore,
  formatDates,
  getOperationalModel,
  getFormatText,
  getCheckoutInfo,
  translateJsonKeysByCategory,
  standardDate,
  isPickingInProgress
}
